import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(id_object: string) {
    const response = await api.fetch(
      `/api/v2/pictures/index/id_object/${id_object}`,
    )

    return await handleResponse(response)
  }
}
